// Components
import {
  Alert,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";

// Icons
import DnsIcon from "@mui/icons-material/Dns";

// Services
import UserService from "../../../../services/UserService";
import { useState } from "react";

const isUserSubscribed = (user, attribute) => {
  console.log("🚀 ~ isUserSubscribed ~ user:", user.modules);
  if (!user || !user.modules) return false;
  if (!Array.isArray(user?.modules)) return false;
  console.log(user?.modules?.includes(attribute));
  return user?.modules?.includes(attribute);
};

const SubscriptionDetails = ({ user }) => {
  const [error, setError] = useState(null);

  const [isPrivateFreightChecked, setIsPrivateFreightChecked] = useState(isUserSubscribed(user, "private_freight"));
  const [isPrivateFreightLoading, setIsPrivateFreightLoading] = useState(false);

  const [isTrucksChecked, setIsTrucksChecked] = useState(isUserSubscribed(user, "trucks"));
  const [isTrucksLoading, setIsTrucksLoading] = useState(false);

  const [isInvoicesChecked, setIsInvoicesChecked] = useState(isUserSubscribed(user, "invoices"));
  const [isInvoicesLoading, setIsInvoicesLoading] = useState(false);

  const [isExpeditionsChecked, setIsExpeditionsChecked] = useState(isUserSubscribed(user, "expeditions"));
  const [isExpeditionsLoading, setIsExpeditionsLoading] = useState(false);

  const [isTmsChecked, setIsTmsChecked] = useState(isUserSubscribed(user, "tms"));
  const [isTmsLoading, setIsTmsLoading] = useState(false);

  const [isReportingChecked, setIsReportingChecked] = useState(isUserSubscribed(user, "reporting"));
  const [isReportingLoading, setIsReportingLoading] = useState(false);

  const [isFreightBrokersChecked, setIsFreightBrokersChecked] = useState(user?.role_entreprise=='responsable');
  const [isFreightBrokersLoading, setIsFreightBrokersLoading] = useState(false);

  const handlePrivateFreightChange = async () => {
    setError(null);
    setIsPrivateFreightLoading(true);
    try {
      await UserService.toggleStatus(user?.id, "private_freight");
      setIsPrivateFreightChecked(!isPrivateFreightChecked);
    } catch (e) {
      setError(e);
    } finally {
      setIsPrivateFreightLoading(false);
    }
  };

  const handleTrucksChange = async () => {
    setError(null);
    setIsTrucksLoading(true);
    try {
      await UserService.toggleStatus(user?.id, "trucks");
      setIsTrucksChecked(!isTrucksChecked);
    } catch (e) {
      setError(e);
    } finally {
      setIsTrucksLoading(false);
    }
  };

  const handleInvoicesChange = async () => {
    setError(null);
    setIsInvoicesLoading(true);
    try {
      await UserService.toggleStatus(user?.id, "invoices");
      setIsInvoicesChecked(!isInvoicesChecked);
    } catch (e) {
      console.error(e);
    } finally {
      setIsInvoicesLoading(false);
    }
  };

  const handleExpeditionsChange = async () => {
    setError(null);
    setIsExpeditionsLoading(true);
    try {
      await UserService.toggleStatus(user?.id, "expeditions");
      setIsExpeditionsChecked(!isExpeditionsChecked);
    } catch (e) {
      console.error(e);
    } finally {
      setIsExpeditionsLoading(false);
    }
  };

  const handleTmsChange = async () => {
    setError(null);
    setIsTmsLoading(true);
    try {
      await UserService.toggleStatus(user?.id, "tms");
      setIsTmsChecked(!isTmsChecked);
    } catch (e) {
      console.error(e);
    } finally {
      setIsTmsLoading(false);
    }
  };

  const handleReportingChange = async () => {
    setError(null);
    setIsReportingLoading(true);
    try {
      await UserService.toggleStatus(user?.id, "reporting");
      setIsReportingChecked(!isReportingChecked);
    } catch (e) {
      console.error(e);
    } finally {
      setIsReportingLoading(false);
    }
  };

  const handleFreightBrokersChange = async () => {
    setError(null);
    setIsFreightBrokersLoading(true);
    try {
      await UserService.toggleStatus(user?.id, "freight_brokers");
      setIsFreightBrokersChecked(!isFreightBrokersChecked);
    } catch (e) {
      console.error(e);
    } finally {
      setIsFreightBrokersLoading(false);
    }
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2, display: "flex", gap: 1 }}>
          <DnsIcon /> Modules
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Stack spacing={2}>
          {error && <Alert severity="error">{error.message}</Alert>}
          <FormControlLabel
            control={<Switch checked={isPrivateFreightChecked} onChange={handlePrivateFreightChange} />}
            label={isPrivateFreightLoading ? <CircularProgress size={20} /> : "Bourse de fret privée"}
          />
          <FormControlLabel
            control={<Switch checked={isTrucksChecked} onChange={handleTrucksChange} />}
            label={isTrucksLoading ? <CircularProgress size={20} /> : "Camions"}
          />
          <FormControlLabel
            control={<Switch checked={isInvoicesChecked} onChange={handleInvoicesChange} />}
            label={isInvoicesLoading ? <CircularProgress size={20} /> : "Facturation"}
          />
          <FormControlLabel
            control={<Switch checked={isExpeditionsChecked} onChange={handleExpeditionsChange} />}
            label={isExpeditionsLoading ? <CircularProgress size={20} /> : "Expeditions"}
          />
          <FormControlLabel
            control={<Switch checked={isTmsChecked} onChange={handleTmsChange} />}
            label={isTmsLoading ? <CircularProgress size={20} /> : "Tms"}
          />
          <FormControlLabel
            control={<Switch checked={isReportingChecked} onChange={handleReportingChange} />}
            label={isReportingLoading ? <CircularProgress size={20} /> : "Reporting"}
          />
          {user?.role_entreprise!='affreteur' &&  user?.roles?.length > 0 && user?.roles[0] === "ROLE_TRANSPORTEUR" && (
            <FormControlLabel
              control={<Switch checked={isFreightBrokersChecked} onChange={handleFreightBrokersChange} />}
              label={isFreightBrokersLoading ? <CircularProgress size={20} /> : "Gestion des affréteurs"}
            />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default SubscriptionDetails;
